// Generated by GitHub Copilot
import React, { useEffect, useRef, useState } from "react";
import { Alert, Modal } from "react-bootstrap";
import ImpactForm from "./ImpactForm";
import styles from "./ImpactFormModal.module.css";

function ImpactFormModal({
  show,
  onHide,
  onSubmit,
  initialValues,
  loading,
  problemNumber, // Generated by GitHub Copilot - US1803046: Pass problem number for duplicate detection
  title = "Report New Impact",
  error = null,
}) {
  const modalBodyRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Scroll to top when modal opens
  useEffect(() => {
    if (show && modalBodyRef.current) {
      // Reset scroll position immediately
      modalBodyRef.current.scrollTop = 0;

      // Also try after a short delay
      setTimeout(() => {
        if (modalBodyRef.current) {
          modalBodyRef.current.scrollTop = 0;
        }
      }, 50);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered={!isMobile} // Don't center on mobile
      dialogClassName={styles.modalDialog}
      data-testid="impact-form-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body ref={modalBodyRef}>
        {error && <Alert variant="danger">{error}</Alert>}
        <ImpactForm
          onSubmit={onSubmit}
          onCancel={onHide}
          initialValues={initialValues}
          loading={loading}
          problemNumber={problemNumber}
        />
      </Modal.Body>
    </Modal>
  );
}

export default ImpactFormModal;
